import React from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';

const FooterArea = styled.footer`
  background: linear-gradient(180deg, #e3f2fd 0%, #bbdefb 100%);
  border-top: 1px solid #90caf9;
  margin-top: auto;
`;

const FooterTop = styled.div`
  padding: 12px 24px;
  @media (max-width: 679px) {
    padding: 12px 16px;
  }
`;

const CustomContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const CustomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  @media (max-width: 679px) {
    flex-direction: column;
    text-align: center;
  }
`;

const LeftContent = styled.div`
  max-width: 400px;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: #6c757d;
  margin: 0;
  @media (max-width: 679px) {
    display: none;
  }
`;

const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const QrSection = styled.div`
  display: flex;
  gap: 16px;
  @media (max-width: 679px) {
    justify-content: center;
  }
`;

const QrItem = styled.div`
  text-align: center;
`;

const QrLabel = styled.p`
  font-size: 11px;
  color: #6c757d;
  margin: 0 0 2px 0;
`;

const QrWrapper = styled.div`
  background: #f8f9fa;
  border-radius: 6px;
  padding: 5px;
  display: inline-flex;
  border: 1px solid #e1e3e4;
`;

const CopyrightArea = styled.div`
  border-top: 1px solid #bbdefb;
  padding: 6px 24px;
`;

const CopyrightRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CopyrightText = styled.p`
  font-size: 12px;
  color: #6c757d;
  margin: 0;

  a {
    color: #1976d2;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  @media (max-width: 679px) {
    font-size: 11px;
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterArea>
      <FooterTop>
        <CustomContainer>
          <CustomRow>
            <LeftContent>
              <Description>
                AI-powered health monitoring via your camera. Measure vital signs anytime, anywhere.
              </Description>
            </LeftContent>

            <RightContent>
              <QrSection>
                <QrItem>
                  <QrLabel>App Store</QrLabel>
                  <a href="https://apps.apple.com/tw/app/charlycam/id6747739799" target="_blank" rel="noopener noreferrer">
                    <QrWrapper>
                      <QRCodeSVG value="https://apps.apple.com/tw/app/charlycam/id6747739799" size={60} />
                    </QrWrapper>
                  </a>
                </QrItem>
                <QrItem>
                  <QrLabel>Google Play</QrLabel>
                  <a href="https://play.google.com/store/apps/details?id=io.ledgerb.charlycam&hl=zh_TW" target="_blank" rel="noopener noreferrer">
                    <QrWrapper>
                      <QRCodeSVG value="https://play.google.com/store/apps/details?id=io.ledgerb.charlycam&hl=zh_TW" size={60} />
                    </QrWrapper>
                  </a>
                </QrItem>
              </QrSection>
            </RightContent>
          </CustomRow>
        </CustomContainer>
      </FooterTop>

      <CopyrightArea>
        <CustomContainer>
          <CopyrightRow>
            <CopyrightText>
              版權所有 © 2026{' '}
              <a target="_blank" href="https://ledgerb.io" rel="noopener noreferrer">
                LedgerB.io Limited
              </a>
            </CopyrightText>
          </CopyrightRow>
        </CustomContainer>
      </CopyrightArea>
    </FooterArea>
  );
};

export default Footer;
